/*
Plastics

--fireRated <boolean::checkbox>
--manufacturer <Manufacturer>
--manufacturerNumber <string>
--computerEaseNumber <string>
*/
import filters from './filters'
import headers from './headers'
import form from './form'

const name = 'Plastics'
const id = '4pe0phXitTY3W5UWP4mx'

export default {
  name,
  id,
  filters,
  headers,
  form
}
